import { Trans } from '@ecomm/i18n'
import { Modal } from '@ecomm/shared-components/lib/Modal'
//import { toHtmlId } from '@simplisafe/ewok'
import { useState } from 'react'
import type { ReactNode } from 'react'
import { PerDaySlash } from '../A11yHelpers/PerDaySlash'

// TODO [@simplisafe/ewok@>=4.9.1]: Remove this function when we upgrade ewok to a version that includes toHtmlId
const toHtmlId = (title: string): string => title.replace(/\W/g, '_')

type MonitoringPlanModalV2Props = {
  readonly buttonLabel: string | ReactNode
  readonly children: ReactNode
  readonly title: string
  readonly description?: string
}
export function MonitoringPlanModalV2({
  buttonLabel,
  children,
  title,
  description
}: MonitoringPlanModalV2Props) {
  const [isOpen, setIsOpen] = useState(false)
  const id = toHtmlId(title)
  const handleOpenToggle = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <button
        data-testid="MonitoringPlanModalButton"
        className="bg-transparent border-0 p-0 text-inherit font-inherit underline hover:no-underline cursor-pointer"
        onClick={handleOpenToggle}
      >
        {buttonLabel}
      </button>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => {
          setIsOpen(false)
        }}
        aria={{ labelledby: id }}
      >
        <div className="grid gap-4 max-w-3xl p-6 md:p-8 lg:p-12 prose md:prose-md lg:prose-lg">
          <header className="grid gap-4">
            <h2 id={id} className="m-0">
              <Trans components={{ per: <PerDaySlash /> }}>{title}</Trans>
            </h2>
            {description && <p className="m-0">{description}</p>}
          </header>
          {children}
        </div>
      </Modal>
    </>
  )
}
